import { render, staticRenderFns } from "./simple.vue?vue&type=template&id=c988dd7c&scoped=true&"
var script = {}
import style0 from "./simple.vue?vue&type=style&index=0&id=c988dd7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c988dd7c",
  null
  
)

export default component.exports